module.exports = __webpack_public_path__ + "img/right_zh_new.5daf7067.png";